<section class="breadcrumb-section">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="breadcrumb-title">
					<h1>IQAC</h1>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="section-lg std-scholarship">
	<div class="container">
		<div class="row row-50">
			<div class="col-md-3">
				<div class="vertical-tabs">
					<ul class="nav nav-pills flex-column" id="myTab" role="tablist">
						<li class="nav-item">
							<a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab"
								aria-controls="tab1" aria-selected="true"> IQAC</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab"
								aria-controls="tab4" aria-selected="false">IQAC Members</a>
						</li>
						<!-- <li class="nav-item">
                            <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">AQAR</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6" aria-selected="false">MOM</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab7-tab" data-toggle="tab" href="#tab7" role="tab" aria-controls="tab7" aria-selected="false">ATR</a>
                        </li> -->
						<li class="nav-item">
							<a class="nav-link" id="tab11-tab" data-toggle="tab" href="#tab11" role="tab"
								aria-controls="tab11" aria-selected="false">Minutes of Meeting</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab121-tab" data-toggle="tab" href="#tab121" role="tab"
								aria-controls="tab121" aria-selected="false"> AQAR 2022-23</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab122-tab" data-toggle="tab" href="#tab122" role="tab"
								aria-controls="tab122" aria-selected="false"> AQAR </a>
						</li>
						<!-- <li class="nav-item">
							<a class="nav-link" id="tab12-tab" data-toggle="tab" href="#tab12" role="tab"
								aria-controls="tab12" aria-selected="false">AQAR 2021-22</a>
						</li> -->
						<li class="nav-item">
							<a class="nav-link" id="tab8-tab" data-toggle="tab" href="#tab8" role="tab"
								aria-controls="tab8" aria-selected="false">NAAC</a>
						</li>
						<!-- <li class="nav-item">
                            <a class="nav-link" id="tab9-tab" data-toggle="tab" href="#tab9" role="tab" aria-controls="tab9" aria-selected="false">DVV</a>
                        </li> -->
						<!-- <li class="nav-item">
                            <a class="nav-link" id="tab10-tab" data-toggle="tab" href="#tab10" role="tab" aria-controls="tab10" aria-selected="false">SSR</a>
                        </li> -->
					</ul>
				</div>
			</div>
			<div class="col-md-9">
				<div class="tab-content" id="myTabContent">
					<div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
						<!-- <div class="inner-title"  >
                            <h3>Internal Quality Assurance Cell (IQAC)</h3>							
                           
                        </div>
                        <div class="text-justify" >
                            <p>The IQAC is functional in planning and implementation of the infrastructural and the academic upgrade of the College within the ambits of UGC guidelines. It takes into account each teacher's performance in both curricular and extra-curricular areas for their career advancement.</p>
                            <p>With its objective of sustenance and enhancement of quality education, the major thrust areas are student enrolment, student participation, motivation, quality improvement, promotion of quality research culture, enhancement of infrastructural facilities and support services. With the Principal as Chairperson, meetings are conducted periodically to discuss issues relating to academic performance and non-academic matters of the college to foster efficient organization and maintenance of credentials pertaining to the staff and students.</p>
                            <p>The IQAC assists the College authorities in formulating various action plans and strategies to increase the institution’s performance by carefully assessing its strengths, weaknesses, challenges and opportunities. The Cell organizes various programmes and seminars/workshops for the benefit of teaching and non-teaching staff.</p>
                        </div> -->

						<div class="row justify-content-center">
							<div class="col-md-8">
								<div class="inner-title">
									<h3>IQAC</h3>

								</div>
								<div class="text-justify">
									<h5 class="py-3">Objectives</h5>
									<p>
										The IQAC is functional in planning and implementation of the infrastructural and
										the academic upgrade of the College within the ambits of UGC guidelines. It
										takes into account each teacher's
										performance in both curricular and extra-curricular areas for their career
										advancement.
									</p>

									<ul class="list-item">
										<li>To develop a system for conscious, consistent and catalytic improvement in
											the overall performance of the institution</li>
										<li>To channelize all efforts and measures of the institution towards promoting
											its holistic academic excellence</li>
										<li>To ensure continuous improvement in the entire operations of the University
										</li>
									</ul>
								</div>
							</div>
							<div class="col-md-4 col-sm-8">
								<div class="team">
									<figure><img class="img-fluid" src="assets/images/team/kanchan-tiwari.webp"
											alt="Prof-kanchan-tiwari | Ghrcacsn" title="Prof-kanchan-tiwari | Ghrcacsn" /></figure>
									<div class="team-details">
										<h5>Prof. Kanchan Tiwari</h5>
										<h6>IQAC coordinator</h6>
										<p class="mb-0 inner-font"><i class="fa fa-envelope-o"></i> :
											iqac.ccst@raisoni.net</p>
										<p class="mb-0 inner-font"><i class="fa fa-envelope-o"></i> :
											Kanchan.tiwari@raisoni.net</p>
									</div>
								</div>
							</div>
						</div>

						<ul class="list-item">
							<li>To ensure stakeholders connected with higher Education, namely parents, teachers, staff,
								would be employers, funding agencies and society in general, of its own quality and
								probity.</li>
						</ul>
						<div class="text-justify">
							<h5 class="py-3">Functions</h5>
							<ul class="list-item">
								<li>Design and implementation of annual plan for institution – level activities for
									quality enhancement</li>
								<li>Arrange for feedback responses from students for quality – related institutional
									processes</li>
								<li>Development and Applications of quality bench marks / parameters for the various
									academic and administrative activities of the institution</li>
								<li>Retrieval of information on various quality parameters of Higher Education and best
									practices followed by other institutions</li>
								<li>Organizations of Workshops and Seminars on Quality – related themes and promotion of
									quality circles and institutions- wide dissemination of the proceeding of such
									activities</li>
								<li>Development and Application of innovative practices in various programmes /
									activities leading to quality enhancement</li>
								<li>Participation in the creation of learner – centric environment conductive for
									quality education</li>
								<li>Work for the development of Internationalization and Institutionalization of quality
									enhancement policies and practices</li>
								<li>Act as a nodal unit of the institution for augmenting quality – related activities
								</li>
							</ul>
						</div>
					</div>

					<!-- <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">                                
                        <div class="inner-title"  >
                            <h3>Objectives
                            </h3>
                           
                        </div> 
                        <ul class="list-item">
                            <li>To develop a system for conscious, consistent and catalytic improvement in the overall performance of the institution</li>
                            <li>To channelize all efforts and measures of the institution towards promoting its holistic academic excellence</li>
                            <li>To ensure continuous improvement in the entire operations of the University</li>
                            <li>To ensure stakeholders connected with higher Education, namely parents, teachers, staff, would be employers, funding agencies and society in general, of its own quality and probity.</li>
                        </ul>                         
                    </div>

                    <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
                        <div class="inner-title"  >
                            <h3>Functions
                            </h3>
                           
                        </div>
                        <ul class="list-item">
                            <li>Design and implementation of annual plan for institution – level activities for quality enhancement</li>
                            <li>Arrange for feedback responses from students for quality – related institutional processes</li>
                            <li>Development and Applications of quality bench marks / parameters for the various academic and administrative activities of the institution</li>
                            <li>Retrieval of information on various quality parameters of Higher Education and best practices followed by other institutions</li>
                            <li>Organizations of Workshops and Seminars on Quality – related themes and promotion of quality circles and institutions- wide dissemination of the proceeding of such activities</li>
                            <li>Development and Application of innovative practices in various programmes / activities leading to quality enhancement</li>
                            <li>Participation in the creation of learner – centric environment conductive for quality education</li>
                            <li>Work for the development of Internationalization and Institutionalization of quality enhancement policies and practices</li>
                            <li>Act as a nodal unit of the institution for augmenting quality – related activities</li>
                        </ul>
                    </div> -->

					<div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
						<div class="inner-title">
							<h3>IQAC Members</h3>

						</div>
						<h5 class="mb-5">IQAC Cell 2022-23</h5>
						<div class="table-responsive">
							<table class="table table-bordered text-center tbl_custom">
								<thead>
									<tr>
										<th>Sr.NO.</th>
										<th>Name</th>
										<th>Designation</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1</td>
										<td>Dr Jasvinder Kaur</td>
										<td>Principal</td>
									</tr>
									<tr>
										<td>2</td>
										<td>Dr Aarti Deshpande</td>
										<td>Nominee - Management</td>
									</tr>
									<tr>
										<td>3</td>
										<td>Mr. Ashwin Pande</td>
										<td>Employer - Representative</td>
									</tr>
									<tr>
										<td>4</td>
										<td>Mr Ravindra kaskhedikar</td>
										<td>Local Society Nominee</td>
									</tr>
									<tr>
										<td>5</td>
										<td>Mr.Amol Rakshaskar</td>
										<td>Member Administrative Officer</td>
									</tr>
									<tr>
										<td>6</td>
										<td>Dr. Jyoti Samseriya</td>
										<td>Teacher Member</td>
									</tr>
									<tr>
										<td>7</td>
										<td>Dr. Ashwin Ankar</td>
										<td>Teacher Member</td>
									</tr>
									<tr>
										<td>8</td>
										<td>CA Dr. Manish Shah</td>
										<td>Teacher Member</td>
									</tr>
									<tr>
										<td>9</td>
										<td>Mr. Pankaj Pethe</td>
										<td>Teacher Member</td>
									</tr>
									<tr>
										<td>10</td>
										<td>CA Saket Bagdia</td>
										<td>Nominee - Industrialist</td>
									</tr>
									<tr>
										<td>11</td>
										<td>Dr. Girish Katkar</td>
										<td>Nominee - Academician</td>
									</tr>
									<tr>
										<td>12</td>
										<td>Ms. Namrata Liladia</td>
										<td>Nominee - Parents</td>
									</tr>
									<tr>
										<td>13</td>
										<td>Ms. Shabla Sharma</td>
										<td>Nominee - Alumni</td>
									</tr>
									<tr>
										<td>14</td>
										<td>Ms Ananya Saraf</td>
										<td>Nominee - Student</td>
									</tr>
									<tr>
										<td>15</td>
										<td>Ms. Kanchan Tiwari</td>
										<td>IQAC coordinator</td>
									</tr>
								</tbody>
							</table>

							<!-- <table class="table table-bordered text-center tbl_custom">
                                <thead>
                                    <tr>
                                        <th>Sr. No</th>
                                        <th>Name </th>
                                        <th>Designation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>Dr Jasvinder Kaur</td>
                                        <td>Chairperson</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Prof. Madhuri Barua,<br/>
                                            Dr. Jyoti Samseriya,<br/>
                                            Dr. Ashwin Ankar,<br/>
                                            CA Dr. Manish Shah<br/>
                                        </td>
                                        <td> Teacher Members</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Mr. Ashwin Pande</td>
                                        <td>Member/Nominee from Management</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td>Mr Kishore Palkanwar</td>
                                        <td>Senior administrative officer</td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td>Mr Tanishq Chajjer</td>
                                        <td>Student Nominee</td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td>Mr. Kanak Bhowmik</td>
                                        <td>Nominee Alumni</td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td>Mr Aditya Bhandari</td>
                                        <td>Nominee Industrialist</td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td>Mr Ved Agrawal</td>
                                        <td>Nominee Stakeholder</td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td>Dr Aarti Kalnawat, <br/>Symbiosis Instituton, Nagpur</td>
                                        <td>Academician</td>
                                    </tr>
                                    <tr>
                                        <td>10</td>
                                        <td>Dr. Jyoti Mahajan, GHRIMR</td>
                                        <td>Academician</td>
                                    </tr>
                                    <tr>
                                        <td>11</td>
                                        <td>Ms. Kanchan Tiwari</td>
                                        <td>One of the senior teachers as the <br/>coordinator/Director of the IQAC</td>
                                    </tr>
                                </tbody>
                            </table> -->
						</div>
					</div>
					<!-- <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">
                        <div class="inner-title"  >
                            <h3>AQAR
                            </h3>
                           
                        </div>
                    </div> -->
					<!-- <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">
                        <div class="inner-title"  >
                            <h3>MOM
                            </h3>
                           
                        </div>
                        <div class="table-responsive" > 
                            <table class="table table-bordered text-center tbl_custom">
                                <thead>
                                    <tr>
                                        <th>Sr. No</th>
                                        <th>Name </th>
                                        <th>Designation</th>
                                        <th colspan="2">Attendance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>Dr. Aarti Deshpande</td>
                                        <td>Chairperson</td>
                                        <td>Present</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Prof. Madhuri Barua, Prof. Jyoti Samseriya, Dr. Jasvinder Kaur, CA Dr. Manish Shah</td>
                                        <td>Teacher Members</td>
                                        <td>Present</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>MrO.S.Bihade</td>
                                        <td>Member/Nominee from Employers</td>
                                        <td>Present</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td>Mrs Anita Kadam, </td>
                                        <td>Senior administrative officer</td>
                                        <td>Present</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td>Mr Deepak Mourya</td>
                                        <td>Senior administrative officer</td>
                                        <td>Present</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td>Mr Aman Choubey</td>
                                        <td>Student Nominee </td>
                                        <td>Present</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td>Swati Banerjee</td>
                                        <td>Local Society Nominee </td>
                                        <td>&nbsp;</td>
                                        <td>Absent</td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td>Mr. Vinay Sahu</td>
                                        <td>Nominee Alumni </td>
                                        <td>Present</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td>Mr Shabbir Vali</td>
                                        <td>Nominee Industrialist</td>
                                        <td>&nbsp;</td>
                                        <td>Absent</td>
                                    </tr>
                                    <tr>
                                        <td>10</td>
                                        <td>MrVed Agrawal</td>
                                        <td>Nominee Stakeholder</td>
                                        <td>Present</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>11</td>
                                        <td>Mrs Amina Vali from SNDT University</td>
                                        <td>Acamedician</td>
                                        <td>Present</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>12</td>
                                        <td>Dr. Ashwin Ankar</td>
                                        <td>One of the senior teachers as the coordinator/Director of the IQAC</td>
                                        <td>Present</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> -->
					<!-- <div class="tab-pane fade" id="tab7" role="tabpanel" aria-labelledby="tab7-tab">
                        <div class="inner-title"  >
                            <h3>ATR
                            </h3>
                           
                        </div>
                    </div> -->
					<div class="tab-pane fade" id="tab11" role="tabpanel" aria-labelledby="tab11-tab">
						<div class="inner-title">
							<h3>Minutes of Meeting</h3>

						</div>
						<div class="row text-center">
							<!-- <div class="col-md-4">
                                  <div class="pdf-box">
                                      <div class="pdf-icon">
                                          <span><i class="fa fa-file-pdf-o"></i></span>
                                      </div>
                                      <h5>Minutes of Meeting</h5>            
                                      <a class="button-text" href="https://drive.google.com/file/d/1oSg_D7R4prUKS4gzzG81k4-TUBaVVCoD/view?usp=sharing" target="_blank">Read More</a>
                                  </div>
                                </div> -->
							<div class="col-md-4">
								<div class="pdf-box">
									<div class="pdf-icon">
										<span><i class="fa fa-file-pdf-o"></i></span>
									</div>
									<h5>3rd Meeting MOM 2022-23</h5>
									<a class="button-text"
										href="https://drive.google.com/file/d/1fr36UUtNbFnlL16u9gIuXGdZh-cq2JnQ/view?usp=sharing"
										target="_blank">Read More</a>
								</div>
							</div>
							<div class="col-md-4">
								<div class="pdf-box">
									<div class="pdf-icon">
										<span><i class="fa fa-file-pdf-o"></i></span>
									</div>
									<h5>Minutes of Meeting 2021-22</h5>
									<a class="button-text"
										href="https://drive.google.com/file/d/1Mmw_XnaGcSXg49-rl23IL3RcqaHLWz2w/view?usp=sharing"
										target="_blank">Read More</a>
								</div>
							</div>
							<div class="col-md-4">
								<div class="pdf-box">
									<div class="pdf-icon">
										<span><i class="fa fa-file-pdf-o"></i></span>
									</div>
									<h5>Minutes of Meeting</h5>
									<a class="button-text"
										href="https://drive.google.com/file/d/1jO97kBqd5hrrwEVGuluLZQFWon_ycFPP/view?usp=sharing"
										target="_blank">Read More</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab121" role="tabpanel" aria-labelledby="tab121-tab">
						<div class="row">
							<div class="col-md-12">
								<div class="vertical-tabs">
									<ul class="nav nav-pills flex-row" id="myTab" role="tablist">
										<li class="nav-item">
											<a class="nav-link active" id="tab1-8-tab" data-toggle="tab" href="#tab1-8"
												role="tab" aria-controls="tab1-8" aria-selected="true">Criteria 1</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-9-tab" data-toggle="tab" href="#tab1-9"
												role="tab" aria-controls="tab1-9" aria-selected="false">Criteria 2</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-10-tab" data-toggle="tab" href="#tab1-10"
												role="tab" aria-controls="tab1-10" aria-selected="false">Criteria 3</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-11-tab" data-toggle="tab" href="#tab1-11"
												role="tab" aria-controls="tab1-11" aria-selected="false">Criteria 4</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-12-tab" data-toggle="tab" href="#tab1-12"
												role="tab" aria-controls="tab1-12" aria-selected="false">Criteria 5</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-13-tab" data-toggle="tab" href="#tab1-13"
												role="tab" aria-controls="tab1-13" aria-selected="false">Criteria 6</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-14-tab" data-toggle="tab" href="#tab1-14"
												role="tab" aria-controls="tab1-14" aria-selected="false">Criteria 7</a>
										</li>
									</ul>
								</div>
							</div>
							<div class="col-md-12">
								<div class="tab-content" id="myTabContent">
									<div class="tab-pane fade show active" id="tab1-8" role="tabpanel"
										aria-labelledby="tab1-8-tab">
										<div class="inner-title">
											<h3>Criteria 1</h3>

										</div>
										<div id="accordion" class="accordion tab-acc">
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-1">
													<a class="card-title">1.1.1</a>
												</div>
												<div id="iqar-23-1" class="card-body collapse in show"
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.1.1.pdf"
																target="_blank">1.1.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-2">
													<a class="card-title">1.1.2</a>
												</div>
												<div id="iqar-23-2" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-3">
													<a class="card-title">1.1.3</a>
												</div>
												<div id="iqar-23-3" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.1.3.pdf"
																target="_blank">1.1.3</a>
														</li>
														<!-- <li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.1.3.pdf"
																target="_blank">1.1.3</a>
														</li> -->
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-4">
													<a class="card-title">1.2.1</a>
												</div>
												<div id="iqar-23-4" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.2.1.pdf"
																target="_blank">1.2.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-5">
													<a class="card-title">1.2.2</a>
												</div>
												<div id="iqar-23-5" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.2.2-1.2.3.pdf"
																target="_blank">1.2.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-5">
													<a class="card-title">1.2.3</a>
												</div>
												<div id="iqar-23-5" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.2.2-1.2.3.pdf"
																target="_blank">1.2.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-6">
													<a class="card-title">1.3.1</a>
												</div>
												<div id="iqar-23-6" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.3.1.pdf"
																target="_blank">1.3.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-7">
													<a class="card-title">1.3.2</a>
												</div>
												<div id="iqar-23-7" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.3.2.pdf"
																target="_blank">1.3.2</a>

														</li>
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.3.2-supporting.pdf"
																target="_blank">1.3.2 Supporting</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-8">
													<a class="card-title">1.3.3</a>
												</div>
												<div id="iqar-23-8" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.3.3.pdf"
																target="_blank">1.3.3</a>
														</li>
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.3.3-allover.pdf"
																target="_blank">1.3.3 All Over</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-9">
													<a class="card-title">1.4.1</a>
												</div>
												<div id="iqar-23-9" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.4.1-1.4.2.pdf"
																target="_blank">1.4.1</a>
														</li>

														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.4.1-atr.pdf"
																target="_blank">1.4.1 ATR</a>
														</li>
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.4.1-feedback.pdf"
																target="_blank">1.4.1 Feedbck Analysis</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-10">
													<a class="card-title">1.4.2</a>
												</div>
												<div id="iqar-23-10" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-1/1.4.1-1.4.2.pdf"
																target="_blank">1.4.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-11">
													<a class="card-title">1.4.3</a>
												</div>
												<div id="iqar-23-11" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-9" role="tabpanel" aria-labelledby="tab1-9-tab">
										<div class="inner-title">
											<h3>Criteria 2</h3>

										</div>
										<div id="accordion" class="accordion tab-acc">
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-12">
													<a class="card-title">2.1.1</a>
												</div>
												<div id="iqar-23-12" class="card-body collapse in show"
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.1.1.pdf"
																target="_blank">2.1.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-13">
													<a class="card-title">2.1.2</a>
												</div>
												<div id="iqar-23-13" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.1.2.pdf"
																target="_blank">2.1.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-14">
													<a class="card-title">2.1.3</a>
												</div>
												<div id="iqar-23-14" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-15">
													<a class="card-title">2.2.1</a>
												</div>
												<div id="iqar-23-15" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.2.1.pdf"
																target="_blank">2.2.1</a>
														</li>
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.3.1.pdf"
																target="_blank">2.3.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-16">
													<a class="card-title">2.2.2</a>
												</div>
												<div id="iqar-23-16" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.2.2-2.4.1.pdf"
																target="_blank">2.2.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-17">
													<a class="card-title">2.2.3</a>
												</div>
												<div id="iqar-23-17" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-18">
													<a class="card-title">2.3.1</a>
												</div>
												<div id="iqar-23-18" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.3.1.pdf"
																target="_blank">2.3.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-19">
													<a class="card-title">2.3.2</a>
												</div>
												<div id="iqar-23-19" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.3.2.pdf"
																target="_blank">2.3.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-20">
													<a class="card-title">2.3.3</a>
												</div>
												<div id="iqar-23-20" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.3.3.pdf"
																target="_blank">2.3.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-21">
													<a class="card-title">2.4.1</a>
												</div>
												<div id="iqar-23-21" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.4.1.pdf"
																target="_blank">2.4.1</a>
														</li>
													</ul>
													<!-- <ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.4.1.pdf"
																target="_blank">2.4.1</a>
														</li>
													</ul> -->
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-22">
													<a class="card-title">2.4.2</a>
												</div>
												<div id="iqar-23-22" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.4.2.pdf"
																target="_blank">2.4.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-23">
													<a class="card-title">2.4.3</a>
												</div>
												<div id="iqar-23-23" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.4.3.xlsx"
																target="_blank">2.4.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-23-1">
													<a class="card-title">2.5.1</a>
												</div>
												<div id="iqar-23-23-1" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.5.1-2.5.2.pdf"
																target="_blank">2.5.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-23-1-1">
													<a class="card-title">2.5.2</a>
												</div>
												<div id="iqar-23-23-1-1" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.5.1-2.5.2.pdf"
																target="_blank">2.5.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-23-6-1">
													<a class="card-title">2.6.1</a>
												</div>
												<div id="iqar-23-23-6-1" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.6.1.pdf"
																target="_blank">2.6.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-23-6-2">
													<a class="card-title">2.6.2</a>
												</div>
												<div id="iqar-23-23-6-2" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.6.1.pdf"
																target="_blank">2.6.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-23-2">
													<a class="card-title">2.6.3</a>
												</div>
												<div id="iqar-23-23-2" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.6.3.pdf"
																target="_blank">2.6.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-23-3">
													<a class="card-title">2.7.1</a>
												</div>
												<div id="iqar-23-23-3" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-2/2.7.1.pdf"
																target="_blank">2.7.1</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-10" role="tabpanel"
										aria-labelledby="tab1-10-tab">
										<div class="inner-title">
											<h3>Criteria 3</h3>

										</div>
										<div id="accordion" class="accordion tab-acc">
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-24">
													<a class="card-title">3.1.1</a>
												</div>
												<div id="iqar-23-24" class="card-body collapse in show"
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-25">
													<a class="card-title">3.1.2</a>
												</div>
												<div id="iqar-23-25" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-26">
													<a class="card-title">3.1.3</a>
												</div>
												<div id="iqar-23-26" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-3/3.1.3.pdf"
																target="_blank">3.1.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-27">
													<a class="card-title">3.2.1</a>
												</div>
												<div id="iqar-23-27" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-3/3.2.1.pdf"
																target="_blank">3.2.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-28">
													<a class="card-title">3.2.2</a>
												</div>
												<div id="iqar-23-28" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-3/3.2.2.pdf"
																target="_blank">3.2.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-29">
													<a class="card-title">3.2.3</a>
												</div>
												<div id="iqar-23-29" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-30">
													<a class="card-title">3.3.1</a>
												</div>
												<div id="iqar-23-30" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-31">
													<a class="card-title">3.3.2</a>
												</div>
												<div id="iqar-23-31" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-3/3.3.2.pdf"
																target="_blank">3.3.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-32">
													<a class="card-title">3.3.3</a>
												</div>
												<div id="iqar-23-32" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-3/3.3.3.pdf"
																target="_blank">3.3.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-33">
													<a class="card-title">3.4.1</a>
												</div>
												<div id="iqar-23-33" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-3/3.4.1.pdf"
																target="_blank">3.4.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-34">
													<a class="card-title">3.4.2</a>
												</div>
												<div id="iqar-23-34" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-3/3.4.1.pdf"
																target="_blank">3.4.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-35">
													<a class="card-title">3.4.3</a>
												</div>
												<div id="iqar-23-35" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-11" role="tabpanel"
										aria-labelledby="tab1-11-tab">
										<div class="inner-title">
											<h3>Criteria 4</h3>

										</div>
										<div id="accordion" class="accordion tab-acc">
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-36">
													<a class="card-title">4.1.1</a>
												</div>
												<div id="iqar-23-36" class="card-body collapse in show"
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-37">
													<a class="card-title">4.1.2</a>
												</div>
												<div id="iqar-23-37" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-38">
													<a class="card-title">4.1.3</a>
												</div>
												<div id="iqar-23-38" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.1.3.pdf"
																target="_blank">4.1.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-38-1">
													<a class="card-title">4.1.4</a>
												</div>
												<div id="iqar-23-38-1" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.1.4.pdf"
																target="_blank">4.1.4</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-39">
													<a class="card-title">4.2.1</a>
												</div>
												<div id="iqar-23-39" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.2.1.pdf"
																target="_blank">4.2.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-40">
													<a class="card-title">4.2.2</a>
												</div>
												<div id="iqar-23-40" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.2.2.pdf"
																target="_blank">4.2.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-41">
													<a class="card-title">4.2.3</a>
												</div>
												<div id="iqar-23-41" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.2.3.pdf"
																target="_blank">4.2.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-41-1">
													<a class="card-title">4.2.4</a>
												</div>
												<div id="iqar-23-41-1" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.2.4.pdf"
																target="_blank">4.2.4</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-42">
													<a class="card-title">4.3.1</a>
												</div>
												<div id="iqar-23-42" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.3.1.pdf"
																target="_blank">4.3.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-43">
													<a class="card-title">4.3.2</a>
												</div>
												<div id="iqar-23-43" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.3.2.pdf"
																target="_blank">4.3.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-44">
													<a class="card-title">4.3.3</a>
												</div>
												<div id="iqar-23-44" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.3.3.pdf"
																target="_blank">4.3.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-45">
													<a class="card-title">4.4.1</a>
												</div>
												<div id="iqar-23-45" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.4.1.pdf"
																target="_blank">4.4.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-46">
													<a class="card-title">4.4.2</a>
												</div>
												<div id="iqar-23-46" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-4/4.4.2.pdf"
																target="_blank">4.4.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-47">
													<a class="card-title">4.4.3</a>
												</div>
												<div id="iqar-23-47" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-12" role="tabpanel"
										aria-labelledby="tab1-12-tab">
										<div class="inner-title">
											<h3>Criteria 5</h3>

										</div>
										<div id="accordion" class="accordion tab-acc">
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-48">
													<a class="card-title">5.1.1</a>
												</div>
												<div id="iqar-23-48" class="card-body collapse in show"
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.1.1.pdf"
																target="_blank">5.1.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-49">
													<a class="card-title">5.1.2</a>
												</div>
												<div id="iqar-23-49" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.1.3.pdf"
																target="_blank">5.1.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-50">
													<a class="card-title">5.1.3</a>
												</div>
												<div id="iqar-23-50" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.1.3.pdf"
																target="_blank">5.1.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-50-1">
													<a class="card-title">5.1.4</a>
												</div>
												<div id="iqar-23-50-1" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.1.4.pdf"
																target="_blank">5.1.4</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-50-1515">
													<a class="card-title">5.1.5</a>
												</div>
												<div id="iqar-23-50-1515" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.1.5.pdf"
																target="_blank">5.1.5</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-51">
													<a class="card-title">5.2.1</a>
												</div>
												<div id="iqar-23-51" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.2.1.pdf"
																target="_blank">5.2.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-52">
													<a class="card-title">5.2.2</a>
												</div>
												<div id="iqar-23-52" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.2.2.pdf"
																target="_blank">5.2.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-53">
													<a class="card-title">5.2.3</a>
												</div>
												<div id="iqar-23-53" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.2.3.pdf"
																target="_blank">5.2.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-54">
													<a class="card-title">5.3.1</a>
												</div>
												<div id="iqar-23-54" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.3.1.pdf"
																target="_blank">5.3.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-55">
													<a class="card-title">5.3.2</a>
												</div>
												<div id="iqar-23-55" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-56">
													<a class="card-title">5.3.3</a>
												</div>
												<div id="iqar-23-56" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-5/5.3.3.pdf"
																target="_blank">5.3.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-57">
													<a class="card-title">5.4.1</a>
												</div>
												<div id="iqar-23-57" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-58">
													<a class="card-title">5.4.2</a>
												</div>
												<div id="iqar-23-58" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-59">
													<a class="card-title">5.4.3</a>
												</div>
												<div id="iqar-23-59" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-13" role="tabpanel"
										aria-labelledby="tab1-13-tab">
										<div class="inner-title">
											<h3>Criteria 6</h3>

										</div>
										<div id="accordion" class="accordion tab-acc">
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-60">
													<a class="card-title">6.1.1</a>
												</div>
												<div id="iqar-23-60" class="card-body collapse in show"
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-61">
													<a class="card-title">6.1.2</a>
												</div>
												<div id="iqar-23-61" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-62">
													<a class="card-title">6.1.3</a>
												</div>
												<div id="iqar-23-62" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-63">
													<a class="card-title">6.2.1</a>
												</div>
												<div id="iqar-23-63" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-64">
													<a class="card-title">6.2.2</a>
												</div>
												<div id="iqar-23-64" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-6/6.2.2.pdf"
																target="_blank">6.2.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-65">
													<a class="card-title">6.2.3</a>
												</div>
												<div id="iqar-23-65" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-6/6.2.3.pdf"
																target="_blank">6.2.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-66">
													<a class="card-title">6.3.1</a>
												</div>
												<div id="iqar-23-66" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-6/6.3.1.pdf"
																target="_blank">6.3.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-67">
													<a class="card-title">6.3.2</a>
												</div>
												<div id="iqar-23-67" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-6/6.3.2.pdf"
																target="_blank">6.3.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-68">
													<a class="card-title">6.3.3</a>
												</div>
												<div id="iqar-23-68" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-6/6.3.3.pdf"
																target="_blank">6.3.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-68-1">
													<a class="card-title">6.3.4</a>
												</div>
												<div id="iqar-23-68-1" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-6/6.3.4.pdf"
																target="_blank">6.3.4</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-69">
													<a class="card-title">6.4.1</a>
												</div>
												<div id="iqar-23-69" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-70">
													<a class="card-title">6.4.2</a>
												</div>
												<div id="iqar-23-70" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-71">
													<a class="card-title">6.4.3</a>
												</div>
												<div id="iqar-23-71" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-72">
													<a class="card-title">6.5.3</a>
												</div>
												<div id="iqar-23-72" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-6/6.5.3.pdf"
																target="_blank">6.5.3</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-14" role="tabpanel"
										aria-labelledby="tab1-14-tab">
										<div class="inner-title">
											<h3>Criteria 7</h3>

										</div>
										<div id="accordion" class="accordion tab-acc">
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-72">
													<a class="card-title">7.1.1</a>
												</div>
												<div id="iqar-23-72" class="card-body collapse in show"
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.1.pdf"
																target="_blank">7.1.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-73">
													<a class="card-title">7.1.2</a>
												</div>
												<div id="iqar-23-73" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.2.pdf"
																target="_blank">7.1.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-74">
													<a class="card-title">7.1.3</a>
												</div>
												<div id="iqar-23-74" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.3.pdf"
																target="_blank">7.1.3</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-74-1">
													<a class="card-title">7.1.4</a>
												</div>
												<div id="iqar-23-74-1" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.4.pdf"
																target="_blank">7.1.4</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-74-2">
													<a class="card-title">7.1.5</a>
												</div>
												<div id="iqar-23-74-2" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.5.pdf"
																target="_blank">7.1.5</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-74-3">
													<a class="card-title">7.1.6</a>
												</div>
												<div id="iqar-23-74-3" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.6.pdf"
																target="_blank">7.1.6</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-74-4">
													<a class="card-title">7.1.7</a>
												</div>
												<div id="iqar-23-74-4" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.7.pdf"
																target="_blank">7.1.7</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-74-5">
													<a class="card-title">7.1.8</a>
												</div>
												<div id="iqar-23-74-5" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.8.pdf"
																target="_blank">7.1.8</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-74-6">
													<a class="card-title">7.1.9</a>
												</div>
												<div id="iqar-23-74-6" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.9.pdf"
																target="_blank">7.1.9</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-74-7">
													<a class="card-title">7.1.10</a>
												</div>
												<div id="iqar-23-74-7" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.10.pdf"
																target="_blank">7.1.10</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-74-8">
													<a class="card-title">7.1.11</a>
												</div>
												<div id="iqar-23-74-8" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.1.11.pdf"
																target="_blank">7.1.11</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-75">
													<a class="card-title">7.2.1</a>
												</div>
												<div id="iqar-23-75" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.2.1.pdf"
																target="_blank">7.2.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-75-1">
													<a class="card-title">7.2.1.1</a>
												</div>
												<div id="iqar-23-75-1" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.2.1.1.pdf"
																target="_blank">7.2.1.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-75-2">
													<a class="card-title">7.2.1.2</a>
												</div>
												<div id="iqar-23-75-2" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.2.1.2.pdf"
																target="_blank">7.2.1.2</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-76">
													<a class="card-title">7.2.2</a>
												</div>
												<div id="iqar-23-76" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-77">
													<a class="card-title">7.2.3</a>
												</div>
												<div id="iqar-23-77" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-78">
													<a class="card-title">7.3.1</a>
												</div>
												<div id="iqar-23-78" class="card-body collapse "
													data-parent="#accordion">
													<ul class="list-item">
														<li>
															<a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/criteria-7/7.3.1.pdf"
																target="_blank">7.3.1</a>
														</li>
													</ul>
												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-79">
													<a class="card-title">7.3.2</a>
												</div>
												<div id="iqar-23-79" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-80">
													<a class="card-title">7.3.3</a>
												</div>
												<div id="iqar-23-80" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-81">
													<a class="card-title">7.4.1</a>
												</div>
												<div id="iqar-23-81" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-82">
													<a class="card-title">7.4.2</a>
												</div>
												<div id="iqar-23-82" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
											<div class="card">
												<div class="card-header collapsed" data-toggle="collapse"
													href="#iqar-23-83">
													<a class="card-title">7.4.3</a>
												</div>
												<div id="iqar-23-83" class="card-body collapse "
													data-parent="#accordion">

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab122" role="tabpanel" aria-labelledby="tab122-tab">
						<div class="inner-title">
							<h3>AQAR 2021-22</h3>

						</div>
						<div class="row text-center">
							<div class="col-md-4">
								<div class="pdf-box">
									<div class="pdf-icon">
										<span><i class="fa fa-file-pdf-o"></i></span>
									</div>
									<h5>AQAR 2021-22</h5>
									<a class="button-text"
										href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/aqar-21-22.pdf"
										target="_blank">Read More</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab12" role="tabpanel" aria-labelledby="tab12-tab">
						<div class="row">
							<div class="col-md-12">
								<div class="vertical-tabs">
									<ul class="nav nav-pills flex-row" id="myTab" role="tablist">
										<li class="nav-item">
											<a class="nav-link active" id="tab1-1-tab" data-toggle="tab" href="#tab1-1"
												role="tab" aria-controls="tab1-1" aria-selected="true">Criteria 1</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-2-tab" data-toggle="tab" href="#tab1-2"
												role="tab" aria-controls="tab1-2" aria-selected="false">Criteria 2</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-3-tab" data-toggle="tab" href="#tab1-3"
												role="tab" aria-controls="tab1-3" aria-selected="false">Criteria 3</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-4-tab" data-toggle="tab" href="#tab1-4"
												role="tab" aria-controls="tab1-4" aria-selected="false">Criteria 4</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-5-tab" data-toggle="tab" href="#tab1-5"
												role="tab" aria-controls="tab1-5" aria-selected="false">Criteria 5</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-6-tab" data-toggle="tab" href="#tab1-6"
												role="tab" aria-controls="tab1-6" aria-selected="false">Criteria 6</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="tab1-7-tab" data-toggle="tab" href="#tab1-7"
												role="tab" aria-controls="tab1-7" aria-selected="false">Criteria 7</a>
										</li>
									</ul>
								</div>
							</div>
							<div class="col-md-12">
								<div class="tab-content" id="myTabContent">
									<div class="tab-pane fade show active" id="tab1-1" role="tabpanel"
										aria-labelledby="tab1-1-tab">
										<div class="inner-title">
											<h3>Criteria 1</h3>

										</div>
										<div class="row">
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															href="#c1">
															<a class="card-title">1.1.1</a>
														</div>
														<div id="c1" class="card-body collapse in show"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c2">
															<a class="card-title">1.1.2</a>
														</div>
														<div id="c2" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c3">
															<a class="card-title">1.1.3</a>
														</div>
														<div id="c3" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c4">
															<a class="card-title">1.2.1</a>
														</div>
														<div id="c4" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c4">
															<a class="card-title">1.2.2</a>
														</div>
														<div id="c4" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c5">
															<a class="card-title">1.2.3</a>
														</div>
														<div id="c5" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c6">
															<a class="card-title">1.3.1</a>
														</div>
														<div id="c6" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c7">
															<a class="card-title">1.3.2</a>
														</div>
														<div id="c7" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li>
																	<a href="https://drive.google.com/file/d/187jYCY--ib3ii0NlowsAnCD8i7X9TOcR/view?usp=sharing"
																		target="_blank">Combined Project Certificates of
																		BBA and BCCA-III-2021-22</a>
																</li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c8">
															<a class="card-title">1.3.3</a>
														</div>
														<div id="c8" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li>
																	<a href="https://drive.google.com/file/d/187jYCY--ib3ii0NlowsAnCD8i7X9TOcR/view?usp=sharing"
																		target="_blank">Combined Project Certificates of
																		BBA and BCCA-III-2021-22</a>
																</li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c9">
															<a class="card-title">1.4.1</a>
														</div>
														<div id="c9" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c10">
															<a class="card-title">1.4.2</a>
														</div>
														<div id="c10" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1ni5QBIfTcWtitXblC4bBCkdo1VNtFgVj/view?usp=sharing"
																		target="_blank">Feedback Form</a></li>
																<li><a href="https://drive.google.com/file/d/1EQ1rac2EfyZerzo2pr5QbDJFqxyn91C0/view?usp=sharing"
																		target="_blank">Action Taken Report</a></li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-2" role="tabpanel" aria-labelledby="tab1-2-tab">
										<div class="inner-title">
											<h3>Criteria 2</h3>

										</div>
										<div class="row">
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															href="#c1">
															<a class="card-title">2.1.1</a>
														</div>
														<div id="c1" class="card-body collapse in show"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c2">
															<a class="card-title">2.1.2</a>
														</div>
														<div id="c2" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c3">
															<a class="card-title">2.1.3</a>
														</div>
														<div id="c3" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c4">
															<a class="card-title">2.2.1</a>
														</div>
														<div id="c4" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c5">
															<a class="card-title">2.3.2</a>
														</div>
														<div id="c5" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/18BP3s85J2xA6x--Q4fNwYyBGG7JJJrYl/view?usp=sharing"
																		target="_blank">2.3.2</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c6">
															<a class="card-title">2.7.1</a>
														</div>
														<div id="c6" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1mZIm7qKQska3XxeJWE9KY4Z1BfWgiYVr/view?usp=sharing"
																		target="_blank">2.7.1</a></li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-3" role="tabpanel" aria-labelledby="tab1-3-tab">
										<div class="inner-title">
											<h3>Criteria 3</h3>

										</div>
										<div class="row">
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															href="#c1">
															<a class="card-title">3.1.1</a>
														</div>
														<div id="c1" class="card-body collapse in show"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c2">
															<a class="card-title">3.1.2</a>
														</div>
														<div id="c2" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c3">
															<a class="card-title">3.1.3</a>
														</div>
														<div id="c3" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1OR4cpP7WoEtchjtTWmDQ-qxlden6Dzb3/view?usp=sharing"
																		target="_blank">3.1.3</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c4">
															<a class="card-title">3.3.1</a>
														</div>
														<div id="c4" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1LkOlNETQuMCtjBHH5mdbbP1nafzHavQQ/view?usp=sharing"
																		target="_blank">3.3.1_new</a></li>
															</ul>
														</div>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c5">
															<a class="card-title">3.3.5</a>
														</div>
														<div id="c5" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c6">
															<a class="card-title">3.4.1</a>
														</div>
														<div id="c6" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1uJZzZqCLWNFSu9r5-izcRBe-YM7KNFy1/view?usp=sharing"
																		target="_blank">3.4.1 Final data for AQAR</a>
																</li>
															</ul>
														</div>
													</div>

													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c7">
															<a class="card-title">3.4.2</a>
														</div>
														<div id="c7" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1cAeRV_mXENtTzgugSw3bd7Ti4BUlUs4d/view?usp=sharing"
																		target="_blank">3.4.2</a></li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-4" role="tabpanel" aria-labelledby="tab1-4-tab">
										<div class="inner-title">
											<h3>Criteria 4</h3>

										</div>
										<div class="row">
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															href="#c1">
															<a class="card-title">4.1.1</a>
														</div>
														<div id="c1" class="card-body collapse in show"
															data-parent="#accordion">
															<ul class="list-item">
																<!-- <li><a href="https://drive.google.com/file/d/1SZLoLA0biLH-pjR0YP3z5CrBQjWCM3OS/view?usp=sharing" target="_blank">4.1.1</a></li> -->
																<li><a href="https://drive.google.com/file/d/1KHwxy6Tvc6B_wgU52n0XmtNxYQDA82lt/view"
																		target="_blank">4.1.1</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c2">
															<a class="card-title">4.1.2</a>
														</div>
														<div id="c2" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<!-- <li><a href="https://drive.google.com/file/d/1fqnv70Hyg4v1k8eW-Ka6YHqu2CVotBV1/view?usp=sharing" target="_blank">4.1.2</a></li> -->
																<li><a href="https://drive.google.com/file/d/1QUslLZ4cHc9aHXIvAER7Pe7zkwjhyXfg/view"
																		target="_blank">4.1.2</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c3">
															<a class="card-title">4.1.3</a>
														</div>
														<div id="c3" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1Jgbat3lQ4ZevXU65yUfTmBY9zGLOQM2B/view"
																		target="_blank">4.1.3</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c4">
															<a class="card-title">4.2.1</a>
														</div>
														<div id="c4" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/11BtwKboY4s29hjKU-_gVx1KUMKoaiGbP/view?usp=sharing"
																		target="_blank">4.2.1</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c5">
															<a class="card-title">4.2.2</a>
														</div>
														<div id="c5" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1NbXN_JzH6rIvfrkFWA5bbcXDM51vKKDq/view?usp=sharing"
																		target="_blank">4.2.2</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c6">
															<a class="card-title">4.2.3</a>
														</div>
														<div id="c6" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1GcqiICLY3gQUZm0MS54M2Ky94Jjr40kW/view?usp=sharing"
																		target="_blank">4.2.3</a></li>
															</ul>
														</div>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c7">
															<a class="card-title">4.2.4</a>
														</div>
														<div id="c7" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<!-- <li><a href="https://drive.google.com/file/d/1lhxap7FiMqX-hqEC8_b7zoWVciteLh8H/view?usp=sharing" target="_blank">4.2.4</a></li> -->
																<li><a href="https://drive.google.com/file/d/10-tfaMwg5c4LJ9VhZaaZd0IbY5lRicMk/view"
																		target="_blank">4.2.4</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c8">
															<a class="card-title">4.3.1</a>
														</div>
														<div id="c8" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1XwGrM4Qvsw7JmJcWW5UX4c_gZygTIkaB/view"
																		target="_blank">4.3.1</a></li>
																<!-- <li><a href="https://drive.google.com/file/d/1ds1u2sQ4-qZo3mR2qK3XngDuVW6CcKnv/view?usp=sharing" target="_blank">4.3.1</a></li> -->
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c9">
															<a class="card-title">4.3.2</a>
														</div>
														<div id="c9" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<!-- <li><a href="https://drive.google.com/file/d/1AkFz4PjIwxjiBSbqLAAsuNmkb42BF4Kx/view?usp=sharing" target="_blank">4.3.2</a></li> -->
																<li><a href="https://drive.google.com/file/d/1hOFJjqUAJMY1PoymzGtKm1AC3fUMoPOt/view"
																		target="_blank">4.3.2</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c10">
															<a class="card-title">4.3.3</a>
														</div>
														<div id="c10" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/19r-XkchvWvvRz6B2vffMtTFxG-zqebsx/view?usp=sharing"
																		target="_blank">4.3.3</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c11">
															<a class="card-title">4.4.2</a>
														</div>
														<div id="c11" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1Z5gmIjomz5z--TdD1uV0xslvnBDD7HP2/view?usp=sharing"
																		target="_blank">4.4.2</a></li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-5" role="tabpanel" aria-labelledby="tab1-5-tab">
										<div class="inner-title">
											<h3>Criteria 5</h3>

										</div>
										<div class="row">
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															href="#c1">
															<a class="card-title">5.1.1</a>
														</div>
														<div id="c1" class="card-body collapse in show"
															data-parent="#accordion">
															<ul class="list-item">
																<!-- <li><a href="https://drive.google.com/file/d/1tLpB7LdI961TJMbctMO2EKKMVk_xybAw/view?usp=sharing" target="_blank">5.1.2 final 2021-22</a></li> -->
																<li><a href="https://drive.google.com/file/d/1sAi-EBOUDDpR4CzHHGGPOzcX9px837Rn/view?usp=sharing"
																		target="_blank">5.1.1 final 2021-22</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c2">
															<a class="card-title">5.1.2</a>
														</div>
														<div id="c2" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1xhFG6_KiMj0mFyTKl4YMn44-bgE0I-Wy/view?usp=sharing"
																		target="_blank">5.1.1 final 2021-22</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c3">
															<a class="card-title">5.1.3</a>
														</div>
														<div id="c3" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c4">
															<a class="card-title">5.1.4</a>
														</div>
														<div id="c4" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1373iU67ErXgSu5dO0U2pwpEpaN48bcPp/view?usp=sharing"
																		target="_blank">5.1.4 final</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c5">
															<a class="card-title">5.1.5</a>
														</div>
														<div id="c5" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c6">
															<a class="card-title">5.2.2</a>
														</div>
														<div id="c6" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1SY46WgWX7jY7jEJ_PLR0cxVzR-6HFSFO/view?usp=sharing"
																		target="_blank">Criteria 5.2.2-compressed</a>
																</li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c7">
															<a class="card-title">5.2.3</a>
														</div>
														<div id="c7" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1UpQ6pw8Cy_jHPhX_QwSsF9VwETPaOTDd/view?usp=sharing"
																		target="_blank">5.2.3</a></li>
																<li><a href="https://drive.google.com/file/d/1Pxpoz-skXWK67OfnLVLh0f_1CJeUrPhD/view?usp=sharing"
																		target="_blank">Criteria 5.3.2 Qualitative
																		Data</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c8">
															<a class="card-title">5.3.1</a>
														</div>
														<div id="c8" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1n26jGM5DdUFayaKE_y8g_Yw38EhGaxD_/view?usp=sharing"
																		target="_blank">5.3.1 scan</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c9">
															<a class="card-title">5.3.2</a>
														</div>
														<div id="c9" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c9">
															<a class="card-title">5.3.3</a>
														</div>
														<div id="c9" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1U7PWjs3z4vLWniGXDy22Re6zvoM5dUIx/view?usp=sharing"
																		target="_blank">5.3.3 scan</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c10">
															<a class="card-title">5.4.1</a>
														</div>
														<div id="c10" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-6" role="tabpanel" aria-labelledby="tab1-6-tab">
										<div class="inner-title">
											<h3>Criteria 6</h3>

										</div>
										<div class="row">
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															href="#c1">
															<a class="card-title">6.1.1</a>
														</div>
														<div id="c1" class="card-body collapse in show"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c2">
															<a class="card-title">6.1.2</a>
														</div>
														<div id="c2" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c3">
															<a class="card-title">6.1.3</a>
														</div>
														<div id="c3" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c3">
															<a class="card-title">6.1.4</a>
														</div>
														<div id="c3" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c3">
															<a class="card-title">6.1.5</a>
														</div>
														<div id="c3" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c7">
															<a class="card-title">6.2.2</a>
														</div>
														<div id="c7" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1i32EwQyxTxn_ml9A59AmLS-qWxPiE4ED/view?usp=sharing"
																		target="_blank">6.2.2</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c4">
															<a class="card-title">6.2.3</a>
														</div>
														<div id="c4" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c5">
															<a class="card-title">6.3.1</a>
														</div>
														<div id="c5" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/144IMOAGD4o7Za-TbuJchMKLCZLDrv4tG/view?usp=sharing"
																		target="_blank">6.3.1</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c6">
															<a class="card-title">6.3.2</a>
														</div>
														<div id="c6" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c7">
															<a class="card-title">6.3.3</a>
														</div>
														<div id="c7" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/16FYpvhCES_bw8or29kIgs_sM_Fu3KbcK/view?usp=sharing"
																		target="_blank">6.3.3 scan</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c8">
															<a class="card-title">6.3.4</a>
														</div>
														<div id="c8" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a
																		href="https://drive.google.com/file/d/1CcLW5xDEs1cit2SFeqir6nOy40o3NQOs/view?usp=sharing">6.3.4
																		scan</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c9">
															<a class="card-title">6.5.1</a>
														</div>
														<div id="c9" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a
																		href="https://drive.google.com/file/d/1aP39IXL0pNyRHV-VfVTCpz8NWG3r1wDN/view?usp=sharing">6.5.1</a>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="tab1-7" role="tabpanel" aria-labelledby="tab1-7-tab">
										<div class="inner-title">
											<h3>Criteria 7</h3>

										</div>
										<div class="row">
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															href="#c1">
															<a class="card-title">7.1.1</a>
														</div>
														<div id="c1" class="card-body collapse in show"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1-R5UUGohdZLUYJRK6J9cce2XSTWIMB5L/view?usp=sharing"
																		target="_blank">7.1.1</a></li>
																<li><a href="https://drive.google.com/file/d/1NyrdpwN3PvHz42698yrvqrTfhC0zRRXA/view?usp=sharing"
																		target="_blank">7.1.1 action plan</a></li>
																<!-- <li><a href="https://drive.google.com/file/d/1_-CHW9drQQPOC68b3LnCwG1RdGi23Ozq/view?usp=sharing" target="_blank">7.1.1 Counseling Room</a></li>
                                                       <li><a href="https://drive.google.com/file/d/1sqIXQQl2h9NAPTLBar7abqqQT7Z1CRGL/view?usp=sharing" target="_blank">7.1.1 Safety & Security</a></li> -->
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c2">
															<a class="card-title">7.1.2</a>
														</div>
														<div id="c2" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/153cZerbIod8xli-vX9jOup-VsxgK7ZKC/view?usp=sharing"
																		target="_blank">7.1.2</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c3">
															<a class="card-title">7.1.3</a>
														</div>
														<div id="c3" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1aqxpRQ5QQ-bmuD9pKUoCIrSwHWL-BSuq/view?usp=sharing"
																		target="_blank">7.1.3</a></li>
																<!-- <li><a href="https://drive.google.com/file/d/1Y4JGShjXeRYUxY21cQwsZJezdcZM4YKx/view?usp=sharing" target="_blank">7.1.3.1</a></li>
                                                       <li><a href="https://drive.google.com/file/d/1EGkZQonYJVnCIYzAX0ihOBY1Rjt9-92i/view?usp=sharing" target="_blank">7.1.3.2</a></li>                                                       
                                                       <li><a href="https://drive.google.com/file/d/1lCyKIvWxtnVnASzCoz18T8Q12ifZSD0l/view?usp=sharing" target="_blank">7.1.3.3</a></li> -->
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c4">
															<a class="card-title">7.1.4</a>
														</div>
														<div id="c4" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<!-- <li><a href="https://drive.google.com/file/d/126aV2-xGg7iFYMn7ia7kajs14u9YT8Fj/view?usp=sharing" target="_blank">7.1.4 Open Well</a></li>
                                                        <li><a href="https://drive.google.com/file/d/17S7IAMBuVWMsgKVqufXUJ4ox0r6FhCHy/view?usp=sharing" target="_blank">7.1.4 Water Recycling</a></li>
                                                        <li><a href="https://drive.google.com/file/d/1amPjvvmxsFD7ULwdC95ubhKZ2OieH0B5/view?usp=sharing" target="_blank">7.1.4 Water RO system</a></li> -->
																<li><a href="https://drive.google.com/file/d/16NRSqIKCK8TtiWUxu1FXX0XsOtkPSIi-/view?usp=sharing"
																		target="_blank">7.1.4</a></li>
															</ul>
														</div>
													</div>

													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c5">
															<a class="card-title">7.1.5</a>
														</div>
														<div id="c5" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1HI0lm3n05yV8EZuakuclIJn7npMt3qRS/view?usp=sharing"
																		target="_blank">7.1.5</a></li>
																<!-- <li><a href="https://drive.google.com/file/d/1htqaz45TtY8kcjzrCJUd7PWv1UV_bklM/view?usp=sharing" target="_blank">7.1.5.1 College Transportation</a></li>
                                                       <li><a href="https://drive.google.com/file/d/1v8TAfFhVaj8QqfYPd3GFdD985CPweV4Q/view?usp=sharing" target="_blank">7.1.5.2 Ban use of Plastic</a></li>
                                                       <li><a href="https://drive.google.com/file/d/1ajzpyZeg7UORCvuDm24GQ2Krdh-x9T2l/view?usp=sharing" target="_blank">7.1.5.3 Landscaping</a></li> -->
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c6">
															<a class="card-title">7.1.6</a>
														</div>
														<div id="c6" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1VTtM-EIdJz0jkn38T5WGoZJca-QaZxjH/view?usp=sharing"
																		target="_blank">7.1.6.2 Certificate for
																		Environment Activity</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c7">
															<a class="card-title">7.1.7</a>
														</div>
														<div id="c7" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<!-- <li><a href="https://drive.google.com/file/d/1rouSKt6z3_gjVzejxRbTqTh3yFsTvPEv/view?usp=sharing" target="_blank">7.1.7.1 Ramp Rails</a></li>
                                                        <li><a href="https://drive.google.com/file/d/1kGy2brr9KRe99tJDpMEDTPKjxxgC1E37/view?usp=sharing" target="_blank">7.1.7.2 Differently Abled Restroom</a></li> -->
																<li><a href="https://drive.google.com/file/d/1n-N8_nZkKlONY0OERVSFGG_BXtSMqba5/view?usp=sharing"
																		target="_blank">7.1.7</a></li>
															</ul>
														</div>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div id="accordion" class="accordion">
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c8">
															<a class="card-title">7.1.10</a>
														</div>
														<div id="c8" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1gtfIPU5ngnRZtyHgmiwqfvn9SaaQGYw4/view?usp=sharing"
																		target="_blank">7.1.10 Code of Conduct</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c9">
															<a class="card-title">7.2.1</a>
														</div>
														<div id="c9" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1od9MmYwU3DSFLD8cHVQ0xlxP-1UGXBsV/view?usp=sharing"
																		target="_blank">7.2.1</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c10">
															<a class="card-title">7.3.1</a>
														</div>
														<div id="c10" class="card-body collapse"
															data-parent="#accordion">
															<ul class="list-item">
																<li><a href="https://drive.google.com/file/d/1mz-fJx0NZ7b7eFT6FcPW1-x7gj_IipUG/view?usp=sharing"
																		target="_blank">7.3.1</a></li>
															</ul>
														</div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c11">
															<a class="card-title">7.3.2</a>
														</div>
														<div id="c11" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c12">
															<a class="card-title">7.3.3</a>
														</div>
														<div id="c12" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
													<div class="card">
														<div class="card-header collapsed" data-toggle="collapse"
															data-parent="#accordion" href="#c13">
															<a class="card-title">7.4.1</a>
														</div>
														<div id="c13" class="card-body collapse"
															data-parent="#accordion"></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab8" role="tabpanel" aria-labelledby="tab8-tab">
						<div class="inner-title">
							<h3>NAAC</h3>

						</div>
						<div class="row text-center">
							<div class="col-md-4">
								<div class="pdf-box">
									<div class="pdf-icon">
										<span><i class="fa fa-file-pdf-o"></i></span>
									</div>
									<h5>NAAC Certificate</h5>
									<a class="button-text"
										href="https://drive.google.com/file/d/17EoUoVBjUJ_RiwX_aN0fbRrHqJBhLPEc/view?usp=sharing"
										target="_blank">Read More</a>
								</div>
							</div>
							<div class="col-md-4">
								<div class="pdf-box">
									<div class="pdf-icon">
										<span><i class="fa fa-file-pdf-o"></i></span>
									</div>
									<h5>SSR</h5>
									<a class="button-text"
										href="https://drive.google.com/file/d/14FTp_5IEQntnrXbEtLDEhFbFQEwk_TIo/view?usp=sharing"
										target="_blank">Read More</a>
								</div>
							</div>
							<div class="col-md-4">
								<div class="pdf-box">
									<div class="pdf-icon">
										<span><i class="fa fa-file-pdf-o"></i></span>
									</div>
									<h5>IIQA</h5>
									<a class="button-text"
										href="https://drive.google.com/file/d/1o0SB2sAhxs-v89AzvrhLTnQCel2mXSbZ/view?usp=sharing"
										target="_blank">Read More</a>
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="tab-pane fade" id="tab9" role="tabpanel" aria-labelledby="tab9-tab">
                        <div class="inner-title"  >
                            <h3>DVV
                            </h3>
                           
                        </div>
                    </div> -->
					<!-- <div class="tab-pane fade" id="tab10" role="tabpanel" aria-labelledby="tab10-tab">
                        <div class="inner-title"  >
                            <h3>SSR
                            </h3>
                           
                        </div>
                    </div> -->
				</div>
			</div>
		</div>
	</div>
</section>